/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as InvitesAcceptRouteImport } from './routes/invites/accept'
import { Route as DashboardSettingsRouteImport } from './routes/_dashboard/settings'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as DashboardOrgOrgIdRouteRouteImport } from './routes/_dashboard/org/$orgId/route'
import { Route as DashboardOrgOrgIdIndexRouteImport } from './routes/_dashboard/org/$orgId/index'
import { Route as DashboardOrgOrgIdSettingsRouteImport } from './routes/_dashboard/org/$orgId/settings'
import { Route as DashboardOrgOrgIdIntegrationsRouteImport } from './routes/_dashboard/org/$orgId/integrations'
import { Route as DashboardOrgOrgIdFeedRouteImport } from './routes/_dashboard/org/$orgId/feed'
import { Route as DashboardOrgOrgIdIntegrationsIndexRouteImport } from './routes/_dashboard/org/$orgId/integrations/index'
import { Route as DashboardOrgOrgIdCChatIdRouteImport } from './routes/_dashboard/org/$orgId/c/$chatId'
import { Route as DashboardOrgOrgIdWsWsIdRouteRouteImport } from './routes/_dashboard/org/$orgId/ws/$wsId/route'
import { Route as DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteImport } from './routes/_dashboard/org/$orgId/integrations/google-sheets/route'
import { Route as DashboardOrgOrgIdWsWsIdIndexRouteImport } from './routes/_dashboard/org/$orgId/ws/$wsId/index'
import { Route as DashboardOrgOrgIdIntegrationsGoogleSheetsIndexRouteImport } from './routes/_dashboard/org/$orgId/integrations/google-sheets/index'
import { Route as DashboardOrgOrgIdWsWsIdSettingsRouteImport } from './routes/_dashboard/org/$orgId/ws/$wsId/settings'
import { Route as DashboardOrgOrgIdWsWsIdPostsRouteImport } from './routes/_dashboard/org/$orgId/ws/$wsId/posts'
import { Route as DashboardOrgOrgIdIntegrationsGoogleSheetsCreateRouteImport } from './routes/_dashboard/org/$orgId/integrations/google-sheets/create'
import { Route as DashboardOrgOrgIdIntegrationsGoogleSheetsIntegrationIdRouteImport } from './routes/_dashboard/org/$orgId/integrations/google-sheets/$integrationId'
import { Route as DashboardOrgOrgIdCChatIdSettingsRouteImport } from './routes/_dashboard/org/$orgId/c/$chatId/settings'
import { Route as DashboardOrgOrgIdWsWsIdCChatIdRouteImport } from './routes/_dashboard/org/$orgId/ws/$wsId/c/$chatId'
import { Route as DashboardOrgOrgIdWsWsIdCChatIdSettingsRouteImport } from './routes/_dashboard/org/$orgId/ws/$wsId/c/$chatId/settings'

const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const InvitesAcceptRoute = InvitesAcceptRouteImport.update({
  id: '/invites/accept',
  path: '/invites/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authRouteRoute,
} as any)
const DashboardOrgOrgIdRouteRoute = DashboardOrgOrgIdRouteRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardOrgOrgIdIndexRoute = DashboardOrgOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardOrgOrgIdRouteRoute,
} as any)
const DashboardOrgOrgIdSettingsRoute =
  DashboardOrgOrgIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardOrgOrgIdRouteRoute,
  } as any)
const DashboardOrgOrgIdIntegrationsRoute =
  DashboardOrgOrgIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => DashboardOrgOrgIdRouteRoute,
  } as any)
const DashboardOrgOrgIdFeedRoute = DashboardOrgOrgIdFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => DashboardOrgOrgIdRouteRoute,
} as any)
const DashboardOrgOrgIdIntegrationsIndexRoute =
  DashboardOrgOrgIdIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardOrgOrgIdIntegrationsRoute,
  } as any)
const DashboardOrgOrgIdCChatIdRoute =
  DashboardOrgOrgIdCChatIdRouteImport.update({
    id: '/c/$chatId',
    path: '/c/$chatId',
    getParentRoute: () => DashboardOrgOrgIdRouteRoute,
  } as any)
const DashboardOrgOrgIdWsWsIdRouteRoute =
  DashboardOrgOrgIdWsWsIdRouteRouteImport.update({
    id: '/ws/$wsId',
    path: '/ws/$wsId',
    getParentRoute: () => DashboardOrgOrgIdRouteRoute,
  } as any)
const DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRoute =
  DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteImport.update({
    id: '/google-sheets',
    path: '/google-sheets',
    getParentRoute: () => DashboardOrgOrgIdIntegrationsRoute,
  } as any)
const DashboardOrgOrgIdWsWsIdIndexRoute =
  DashboardOrgOrgIdWsWsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardOrgOrgIdWsWsIdRouteRoute,
  } as any)
const DashboardOrgOrgIdIntegrationsGoogleSheetsIndexRoute =
  DashboardOrgOrgIdIntegrationsGoogleSheetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRoute,
  } as any)
const DashboardOrgOrgIdWsWsIdSettingsRoute =
  DashboardOrgOrgIdWsWsIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardOrgOrgIdWsWsIdRouteRoute,
  } as any)
const DashboardOrgOrgIdWsWsIdPostsRoute =
  DashboardOrgOrgIdWsWsIdPostsRouteImport.update({
    id: '/posts',
    path: '/posts',
    getParentRoute: () => DashboardOrgOrgIdWsWsIdRouteRoute,
  } as any)
const DashboardOrgOrgIdIntegrationsGoogleSheetsCreateRoute =
  DashboardOrgOrgIdIntegrationsGoogleSheetsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRoute,
  } as any)
const DashboardOrgOrgIdIntegrationsGoogleSheetsIntegrationIdRoute =
  DashboardOrgOrgIdIntegrationsGoogleSheetsIntegrationIdRouteImport.update({
    id: '/$integrationId',
    path: '/$integrationId',
    getParentRoute: () => DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRoute,
  } as any)
const DashboardOrgOrgIdCChatIdSettingsRoute =
  DashboardOrgOrgIdCChatIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardOrgOrgIdCChatIdRoute,
  } as any)
const DashboardOrgOrgIdWsWsIdCChatIdRoute =
  DashboardOrgOrgIdWsWsIdCChatIdRouteImport.update({
    id: '/c/$chatId',
    path: '/c/$chatId',
    getParentRoute: () => DashboardOrgOrgIdWsWsIdRouteRoute,
  } as any)
const DashboardOrgOrgIdWsWsIdCChatIdSettingsRoute =
  DashboardOrgOrgIdWsWsIdCChatIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardOrgOrgIdWsWsIdCChatIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof DashboardIndexRoute
  '/login': typeof authLoginRoute
  '/settings': typeof DashboardSettingsRoute
  '/invites/accept': typeof InvitesAcceptRoute
  '/org/$orgId': typeof DashboardOrgOrgIdRouteRouteWithChildren
  '/org/$orgId/feed': typeof DashboardOrgOrgIdFeedRoute
  '/org/$orgId/integrations': typeof DashboardOrgOrgIdIntegrationsRouteWithChildren
  '/org/$orgId/settings': typeof DashboardOrgOrgIdSettingsRoute
  '/org/$orgId/': typeof DashboardOrgOrgIdIndexRoute
  '/org/$orgId/integrations/google-sheets': typeof DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteWithChildren
  '/org/$orgId/ws/$wsId': typeof DashboardOrgOrgIdWsWsIdRouteRouteWithChildren
  '/org/$orgId/c/$chatId': typeof DashboardOrgOrgIdCChatIdRouteWithChildren
  '/org/$orgId/integrations/': typeof DashboardOrgOrgIdIntegrationsIndexRoute
  '/org/$orgId/c/$chatId/settings': typeof DashboardOrgOrgIdCChatIdSettingsRoute
  '/org/$orgId/integrations/google-sheets/$integrationId': typeof DashboardOrgOrgIdIntegrationsGoogleSheetsIntegrationIdRoute
  '/org/$orgId/integrations/google-sheets/create': typeof DashboardOrgOrgIdIntegrationsGoogleSheetsCreateRoute
  '/org/$orgId/ws/$wsId/posts': typeof DashboardOrgOrgIdWsWsIdPostsRoute
  '/org/$orgId/ws/$wsId/settings': typeof DashboardOrgOrgIdWsWsIdSettingsRoute
  '/org/$orgId/integrations/google-sheets/': typeof DashboardOrgOrgIdIntegrationsGoogleSheetsIndexRoute
  '/org/$orgId/ws/$wsId/': typeof DashboardOrgOrgIdWsWsIdIndexRoute
  '/org/$orgId/ws/$wsId/c/$chatId': typeof DashboardOrgOrgIdWsWsIdCChatIdRouteWithChildren
  '/org/$orgId/ws/$wsId/c/$chatId/settings': typeof DashboardOrgOrgIdWsWsIdCChatIdSettingsRoute
}
export interface FileRoutesByTo {
  '/login': typeof authLoginRoute
  '/settings': typeof DashboardSettingsRoute
  '/invites/accept': typeof InvitesAcceptRoute
  '/': typeof DashboardIndexRoute
  '/org/$orgId/feed': typeof DashboardOrgOrgIdFeedRoute
  '/org/$orgId/settings': typeof DashboardOrgOrgIdSettingsRoute
  '/org/$orgId': typeof DashboardOrgOrgIdIndexRoute
  '/org/$orgId/c/$chatId': typeof DashboardOrgOrgIdCChatIdRouteWithChildren
  '/org/$orgId/integrations': typeof DashboardOrgOrgIdIntegrationsIndexRoute
  '/org/$orgId/c/$chatId/settings': typeof DashboardOrgOrgIdCChatIdSettingsRoute
  '/org/$orgId/integrations/google-sheets/$integrationId': typeof DashboardOrgOrgIdIntegrationsGoogleSheetsIntegrationIdRoute
  '/org/$orgId/integrations/google-sheets/create': typeof DashboardOrgOrgIdIntegrationsGoogleSheetsCreateRoute
  '/org/$orgId/ws/$wsId/posts': typeof DashboardOrgOrgIdWsWsIdPostsRoute
  '/org/$orgId/ws/$wsId/settings': typeof DashboardOrgOrgIdWsWsIdSettingsRoute
  '/org/$orgId/integrations/google-sheets': typeof DashboardOrgOrgIdIntegrationsGoogleSheetsIndexRoute
  '/org/$orgId/ws/$wsId': typeof DashboardOrgOrgIdWsWsIdIndexRoute
  '/org/$orgId/ws/$wsId/c/$chatId': typeof DashboardOrgOrgIdWsWsIdCChatIdRouteWithChildren
  '/org/$orgId/ws/$wsId/c/$chatId/settings': typeof DashboardOrgOrgIdWsWsIdCChatIdSettingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/_dashboard': typeof DashboardRouteRouteWithChildren
  '/(auth)/login': typeof authLoginRoute
  '/_dashboard/settings': typeof DashboardSettingsRoute
  '/invites/accept': typeof InvitesAcceptRoute
  '/_dashboard/': typeof DashboardIndexRoute
  '/_dashboard/org/$orgId': typeof DashboardOrgOrgIdRouteRouteWithChildren
  '/_dashboard/org/$orgId/feed': typeof DashboardOrgOrgIdFeedRoute
  '/_dashboard/org/$orgId/integrations': typeof DashboardOrgOrgIdIntegrationsRouteWithChildren
  '/_dashboard/org/$orgId/settings': typeof DashboardOrgOrgIdSettingsRoute
  '/_dashboard/org/$orgId/': typeof DashboardOrgOrgIdIndexRoute
  '/_dashboard/org/$orgId/integrations/google-sheets': typeof DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteWithChildren
  '/_dashboard/org/$orgId/ws/$wsId': typeof DashboardOrgOrgIdWsWsIdRouteRouteWithChildren
  '/_dashboard/org/$orgId/c/$chatId': typeof DashboardOrgOrgIdCChatIdRouteWithChildren
  '/_dashboard/org/$orgId/integrations/': typeof DashboardOrgOrgIdIntegrationsIndexRoute
  '/_dashboard/org/$orgId/c/$chatId/settings': typeof DashboardOrgOrgIdCChatIdSettingsRoute
  '/_dashboard/org/$orgId/integrations/google-sheets/$integrationId': typeof DashboardOrgOrgIdIntegrationsGoogleSheetsIntegrationIdRoute
  '/_dashboard/org/$orgId/integrations/google-sheets/create': typeof DashboardOrgOrgIdIntegrationsGoogleSheetsCreateRoute
  '/_dashboard/org/$orgId/ws/$wsId/posts': typeof DashboardOrgOrgIdWsWsIdPostsRoute
  '/_dashboard/org/$orgId/ws/$wsId/settings': typeof DashboardOrgOrgIdWsWsIdSettingsRoute
  '/_dashboard/org/$orgId/integrations/google-sheets/': typeof DashboardOrgOrgIdIntegrationsGoogleSheetsIndexRoute
  '/_dashboard/org/$orgId/ws/$wsId/': typeof DashboardOrgOrgIdWsWsIdIndexRoute
  '/_dashboard/org/$orgId/ws/$wsId/c/$chatId': typeof DashboardOrgOrgIdWsWsIdCChatIdRouteWithChildren
  '/_dashboard/org/$orgId/ws/$wsId/c/$chatId/settings': typeof DashboardOrgOrgIdWsWsIdCChatIdSettingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/settings'
    | '/invites/accept'
    | '/org/$orgId'
    | '/org/$orgId/feed'
    | '/org/$orgId/integrations'
    | '/org/$orgId/settings'
    | '/org/$orgId/'
    | '/org/$orgId/integrations/google-sheets'
    | '/org/$orgId/ws/$wsId'
    | '/org/$orgId/c/$chatId'
    | '/org/$orgId/integrations/'
    | '/org/$orgId/c/$chatId/settings'
    | '/org/$orgId/integrations/google-sheets/$integrationId'
    | '/org/$orgId/integrations/google-sheets/create'
    | '/org/$orgId/ws/$wsId/posts'
    | '/org/$orgId/ws/$wsId/settings'
    | '/org/$orgId/integrations/google-sheets/'
    | '/org/$orgId/ws/$wsId/'
    | '/org/$orgId/ws/$wsId/c/$chatId'
    | '/org/$orgId/ws/$wsId/c/$chatId/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/settings'
    | '/invites/accept'
    | '/'
    | '/org/$orgId/feed'
    | '/org/$orgId/settings'
    | '/org/$orgId'
    | '/org/$orgId/c/$chatId'
    | '/org/$orgId/integrations'
    | '/org/$orgId/c/$chatId/settings'
    | '/org/$orgId/integrations/google-sheets/$integrationId'
    | '/org/$orgId/integrations/google-sheets/create'
    | '/org/$orgId/ws/$wsId/posts'
    | '/org/$orgId/ws/$wsId/settings'
    | '/org/$orgId/integrations/google-sheets'
    | '/org/$orgId/ws/$wsId'
    | '/org/$orgId/ws/$wsId/c/$chatId'
    | '/org/$orgId/ws/$wsId/c/$chatId/settings'
  id:
    | '__root__'
    | '/(auth)'
    | '/_dashboard'
    | '/(auth)/login'
    | '/_dashboard/settings'
    | '/invites/accept'
    | '/_dashboard/'
    | '/_dashboard/org/$orgId'
    | '/_dashboard/org/$orgId/feed'
    | '/_dashboard/org/$orgId/integrations'
    | '/_dashboard/org/$orgId/settings'
    | '/_dashboard/org/$orgId/'
    | '/_dashboard/org/$orgId/integrations/google-sheets'
    | '/_dashboard/org/$orgId/ws/$wsId'
    | '/_dashboard/org/$orgId/c/$chatId'
    | '/_dashboard/org/$orgId/integrations/'
    | '/_dashboard/org/$orgId/c/$chatId/settings'
    | '/_dashboard/org/$orgId/integrations/google-sheets/$integrationId'
    | '/_dashboard/org/$orgId/integrations/google-sheets/create'
    | '/_dashboard/org/$orgId/ws/$wsId/posts'
    | '/_dashboard/org/$orgId/ws/$wsId/settings'
    | '/_dashboard/org/$orgId/integrations/google-sheets/'
    | '/_dashboard/org/$orgId/ws/$wsId/'
    | '/_dashboard/org/$orgId/ws/$wsId/c/$chatId'
    | '/_dashboard/org/$orgId/ws/$wsId/c/$chatId/settings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  InvitesAcceptRoute: typeof InvitesAcceptRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/invites/accept': {
      id: '/invites/accept'
      path: '/invites/accept'
      fullPath: '/invites/accept'
      preLoaderRoute: typeof InvitesAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/_dashboard/org/$orgId': {
      id: '/_dashboard/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof DashboardOrgOrgIdRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/org/$orgId/': {
      id: '/_dashboard/org/$orgId/'
      path: '/'
      fullPath: '/org/$orgId/'
      preLoaderRoute: typeof DashboardOrgOrgIdIndexRouteImport
      parentRoute: typeof DashboardOrgOrgIdRouteRoute
    }
    '/_dashboard/org/$orgId/settings': {
      id: '/_dashboard/org/$orgId/settings'
      path: '/settings'
      fullPath: '/org/$orgId/settings'
      preLoaderRoute: typeof DashboardOrgOrgIdSettingsRouteImport
      parentRoute: typeof DashboardOrgOrgIdRouteRoute
    }
    '/_dashboard/org/$orgId/integrations': {
      id: '/_dashboard/org/$orgId/integrations'
      path: '/integrations'
      fullPath: '/org/$orgId/integrations'
      preLoaderRoute: typeof DashboardOrgOrgIdIntegrationsRouteImport
      parentRoute: typeof DashboardOrgOrgIdRouteRoute
    }
    '/_dashboard/org/$orgId/feed': {
      id: '/_dashboard/org/$orgId/feed'
      path: '/feed'
      fullPath: '/org/$orgId/feed'
      preLoaderRoute: typeof DashboardOrgOrgIdFeedRouteImport
      parentRoute: typeof DashboardOrgOrgIdRouteRoute
    }
    '/_dashboard/org/$orgId/integrations/': {
      id: '/_dashboard/org/$orgId/integrations/'
      path: '/'
      fullPath: '/org/$orgId/integrations/'
      preLoaderRoute: typeof DashboardOrgOrgIdIntegrationsIndexRouteImport
      parentRoute: typeof DashboardOrgOrgIdIntegrationsRoute
    }
    '/_dashboard/org/$orgId/c/$chatId': {
      id: '/_dashboard/org/$orgId/c/$chatId'
      path: '/c/$chatId'
      fullPath: '/org/$orgId/c/$chatId'
      preLoaderRoute: typeof DashboardOrgOrgIdCChatIdRouteImport
      parentRoute: typeof DashboardOrgOrgIdRouteRoute
    }
    '/_dashboard/org/$orgId/ws/$wsId': {
      id: '/_dashboard/org/$orgId/ws/$wsId'
      path: '/ws/$wsId'
      fullPath: '/org/$orgId/ws/$wsId'
      preLoaderRoute: typeof DashboardOrgOrgIdWsWsIdRouteRouteImport
      parentRoute: typeof DashboardOrgOrgIdRouteRoute
    }
    '/_dashboard/org/$orgId/integrations/google-sheets': {
      id: '/_dashboard/org/$orgId/integrations/google-sheets'
      path: '/google-sheets'
      fullPath: '/org/$orgId/integrations/google-sheets'
      preLoaderRoute: typeof DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteImport
      parentRoute: typeof DashboardOrgOrgIdIntegrationsRoute
    }
    '/_dashboard/org/$orgId/ws/$wsId/': {
      id: '/_dashboard/org/$orgId/ws/$wsId/'
      path: '/'
      fullPath: '/org/$orgId/ws/$wsId/'
      preLoaderRoute: typeof DashboardOrgOrgIdWsWsIdIndexRouteImport
      parentRoute: typeof DashboardOrgOrgIdWsWsIdRouteRoute
    }
    '/_dashboard/org/$orgId/integrations/google-sheets/': {
      id: '/_dashboard/org/$orgId/integrations/google-sheets/'
      path: '/'
      fullPath: '/org/$orgId/integrations/google-sheets/'
      preLoaderRoute: typeof DashboardOrgOrgIdIntegrationsGoogleSheetsIndexRouteImport
      parentRoute: typeof DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRoute
    }
    '/_dashboard/org/$orgId/ws/$wsId/settings': {
      id: '/_dashboard/org/$orgId/ws/$wsId/settings'
      path: '/settings'
      fullPath: '/org/$orgId/ws/$wsId/settings'
      preLoaderRoute: typeof DashboardOrgOrgIdWsWsIdSettingsRouteImport
      parentRoute: typeof DashboardOrgOrgIdWsWsIdRouteRoute
    }
    '/_dashboard/org/$orgId/ws/$wsId/posts': {
      id: '/_dashboard/org/$orgId/ws/$wsId/posts'
      path: '/posts'
      fullPath: '/org/$orgId/ws/$wsId/posts'
      preLoaderRoute: typeof DashboardOrgOrgIdWsWsIdPostsRouteImport
      parentRoute: typeof DashboardOrgOrgIdWsWsIdRouteRoute
    }
    '/_dashboard/org/$orgId/integrations/google-sheets/create': {
      id: '/_dashboard/org/$orgId/integrations/google-sheets/create'
      path: '/create'
      fullPath: '/org/$orgId/integrations/google-sheets/create'
      preLoaderRoute: typeof DashboardOrgOrgIdIntegrationsGoogleSheetsCreateRouteImport
      parentRoute: typeof DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRoute
    }
    '/_dashboard/org/$orgId/integrations/google-sheets/$integrationId': {
      id: '/_dashboard/org/$orgId/integrations/google-sheets/$integrationId'
      path: '/$integrationId'
      fullPath: '/org/$orgId/integrations/google-sheets/$integrationId'
      preLoaderRoute: typeof DashboardOrgOrgIdIntegrationsGoogleSheetsIntegrationIdRouteImport
      parentRoute: typeof DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRoute
    }
    '/_dashboard/org/$orgId/c/$chatId/settings': {
      id: '/_dashboard/org/$orgId/c/$chatId/settings'
      path: '/settings'
      fullPath: '/org/$orgId/c/$chatId/settings'
      preLoaderRoute: typeof DashboardOrgOrgIdCChatIdSettingsRouteImport
      parentRoute: typeof DashboardOrgOrgIdCChatIdRoute
    }
    '/_dashboard/org/$orgId/ws/$wsId/c/$chatId': {
      id: '/_dashboard/org/$orgId/ws/$wsId/c/$chatId'
      path: '/c/$chatId'
      fullPath: '/org/$orgId/ws/$wsId/c/$chatId'
      preLoaderRoute: typeof DashboardOrgOrgIdWsWsIdCChatIdRouteImport
      parentRoute: typeof DashboardOrgOrgIdWsWsIdRouteRoute
    }
    '/_dashboard/org/$orgId/ws/$wsId/c/$chatId/settings': {
      id: '/_dashboard/org/$orgId/ws/$wsId/c/$chatId/settings'
      path: '/settings'
      fullPath: '/org/$orgId/ws/$wsId/c/$chatId/settings'
      preLoaderRoute: typeof DashboardOrgOrgIdWsWsIdCChatIdSettingsRouteImport
      parentRoute: typeof DashboardOrgOrgIdWsWsIdCChatIdRoute
    }
  }
}

interface authRouteRouteChildren {
  authLoginRoute: typeof authLoginRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authLoginRoute: authLoginRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteChildren {
  DashboardOrgOrgIdIntegrationsGoogleSheetsIntegrationIdRoute: typeof DashboardOrgOrgIdIntegrationsGoogleSheetsIntegrationIdRoute
  DashboardOrgOrgIdIntegrationsGoogleSheetsCreateRoute: typeof DashboardOrgOrgIdIntegrationsGoogleSheetsCreateRoute
  DashboardOrgOrgIdIntegrationsGoogleSheetsIndexRoute: typeof DashboardOrgOrgIdIntegrationsGoogleSheetsIndexRoute
}

const DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteChildren: DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteChildren =
  {
    DashboardOrgOrgIdIntegrationsGoogleSheetsIntegrationIdRoute:
      DashboardOrgOrgIdIntegrationsGoogleSheetsIntegrationIdRoute,
    DashboardOrgOrgIdIntegrationsGoogleSheetsCreateRoute:
      DashboardOrgOrgIdIntegrationsGoogleSheetsCreateRoute,
    DashboardOrgOrgIdIntegrationsGoogleSheetsIndexRoute:
      DashboardOrgOrgIdIntegrationsGoogleSheetsIndexRoute,
  }

const DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteWithChildren =
  DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRoute._addFileChildren(
    DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteChildren,
  )

interface DashboardOrgOrgIdIntegrationsRouteChildren {
  DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRoute: typeof DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteWithChildren
  DashboardOrgOrgIdIntegrationsIndexRoute: typeof DashboardOrgOrgIdIntegrationsIndexRoute
}

const DashboardOrgOrgIdIntegrationsRouteChildren: DashboardOrgOrgIdIntegrationsRouteChildren =
  {
    DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRoute:
      DashboardOrgOrgIdIntegrationsGoogleSheetsRouteRouteWithChildren,
    DashboardOrgOrgIdIntegrationsIndexRoute:
      DashboardOrgOrgIdIntegrationsIndexRoute,
  }

const DashboardOrgOrgIdIntegrationsRouteWithChildren =
  DashboardOrgOrgIdIntegrationsRoute._addFileChildren(
    DashboardOrgOrgIdIntegrationsRouteChildren,
  )

interface DashboardOrgOrgIdWsWsIdCChatIdRouteChildren {
  DashboardOrgOrgIdWsWsIdCChatIdSettingsRoute: typeof DashboardOrgOrgIdWsWsIdCChatIdSettingsRoute
}

const DashboardOrgOrgIdWsWsIdCChatIdRouteChildren: DashboardOrgOrgIdWsWsIdCChatIdRouteChildren =
  {
    DashboardOrgOrgIdWsWsIdCChatIdSettingsRoute:
      DashboardOrgOrgIdWsWsIdCChatIdSettingsRoute,
  }

const DashboardOrgOrgIdWsWsIdCChatIdRouteWithChildren =
  DashboardOrgOrgIdWsWsIdCChatIdRoute._addFileChildren(
    DashboardOrgOrgIdWsWsIdCChatIdRouteChildren,
  )

interface DashboardOrgOrgIdWsWsIdRouteRouteChildren {
  DashboardOrgOrgIdWsWsIdPostsRoute: typeof DashboardOrgOrgIdWsWsIdPostsRoute
  DashboardOrgOrgIdWsWsIdSettingsRoute: typeof DashboardOrgOrgIdWsWsIdSettingsRoute
  DashboardOrgOrgIdWsWsIdIndexRoute: typeof DashboardOrgOrgIdWsWsIdIndexRoute
  DashboardOrgOrgIdWsWsIdCChatIdRoute: typeof DashboardOrgOrgIdWsWsIdCChatIdRouteWithChildren
}

const DashboardOrgOrgIdWsWsIdRouteRouteChildren: DashboardOrgOrgIdWsWsIdRouteRouteChildren =
  {
    DashboardOrgOrgIdWsWsIdPostsRoute: DashboardOrgOrgIdWsWsIdPostsRoute,
    DashboardOrgOrgIdWsWsIdSettingsRoute: DashboardOrgOrgIdWsWsIdSettingsRoute,
    DashboardOrgOrgIdWsWsIdIndexRoute: DashboardOrgOrgIdWsWsIdIndexRoute,
    DashboardOrgOrgIdWsWsIdCChatIdRoute:
      DashboardOrgOrgIdWsWsIdCChatIdRouteWithChildren,
  }

const DashboardOrgOrgIdWsWsIdRouteRouteWithChildren =
  DashboardOrgOrgIdWsWsIdRouteRoute._addFileChildren(
    DashboardOrgOrgIdWsWsIdRouteRouteChildren,
  )

interface DashboardOrgOrgIdCChatIdRouteChildren {
  DashboardOrgOrgIdCChatIdSettingsRoute: typeof DashboardOrgOrgIdCChatIdSettingsRoute
}

const DashboardOrgOrgIdCChatIdRouteChildren: DashboardOrgOrgIdCChatIdRouteChildren =
  {
    DashboardOrgOrgIdCChatIdSettingsRoute:
      DashboardOrgOrgIdCChatIdSettingsRoute,
  }

const DashboardOrgOrgIdCChatIdRouteWithChildren =
  DashboardOrgOrgIdCChatIdRoute._addFileChildren(
    DashboardOrgOrgIdCChatIdRouteChildren,
  )

interface DashboardOrgOrgIdRouteRouteChildren {
  DashboardOrgOrgIdFeedRoute: typeof DashboardOrgOrgIdFeedRoute
  DashboardOrgOrgIdIntegrationsRoute: typeof DashboardOrgOrgIdIntegrationsRouteWithChildren
  DashboardOrgOrgIdSettingsRoute: typeof DashboardOrgOrgIdSettingsRoute
  DashboardOrgOrgIdIndexRoute: typeof DashboardOrgOrgIdIndexRoute
  DashboardOrgOrgIdWsWsIdRouteRoute: typeof DashboardOrgOrgIdWsWsIdRouteRouteWithChildren
  DashboardOrgOrgIdCChatIdRoute: typeof DashboardOrgOrgIdCChatIdRouteWithChildren
}

const DashboardOrgOrgIdRouteRouteChildren: DashboardOrgOrgIdRouteRouteChildren =
  {
    DashboardOrgOrgIdFeedRoute: DashboardOrgOrgIdFeedRoute,
    DashboardOrgOrgIdIntegrationsRoute:
      DashboardOrgOrgIdIntegrationsRouteWithChildren,
    DashboardOrgOrgIdSettingsRoute: DashboardOrgOrgIdSettingsRoute,
    DashboardOrgOrgIdIndexRoute: DashboardOrgOrgIdIndexRoute,
    DashboardOrgOrgIdWsWsIdRouteRoute:
      DashboardOrgOrgIdWsWsIdRouteRouteWithChildren,
    DashboardOrgOrgIdCChatIdRoute: DashboardOrgOrgIdCChatIdRouteWithChildren,
  }

const DashboardOrgOrgIdRouteRouteWithChildren =
  DashboardOrgOrgIdRouteRoute._addFileChildren(
    DashboardOrgOrgIdRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardOrgOrgIdRouteRoute: typeof DashboardOrgOrgIdRouteRouteWithChildren
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardOrgOrgIdRouteRoute: DashboardOrgOrgIdRouteRouteWithChildren,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  InvitesAcceptRoute: InvitesAcceptRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
